import { render, staticRenderFns } from "./UploadCorrect.vue?vue&type=template&id=6c927c3e&scoped=true"
import script from "./UploadCorrect.vue?vue&type=script&lang=js"
export * from "./UploadCorrect.vue?vue&type=script&lang=js"
import style0 from "./UploadCorrect.vue?vue&type=style&index=0&id=6c927c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c927c3e",
  null
  
)

export default component.exports